export default () => {
    const selectShippingState = document.querySelector('#calc_shipping_state');

    if(! selectShippingState) {
        return;
    }

    jQuery(function($){
        $(document.body).on('change', 'select[name="calc_shipping_state"]', function() {
            $(this).submit();
        });
    });
}
